import { generateUrlBase } from "utils/utils";

import type { ApiCallerT } from "shared/infrastructure/api/types";
import type {
  ApplyRequestsApi,
  ApplyRequestsResponseT,
} from "../types/applyRequests.types";

export const createApplyRequestsApi = (
  apiCaller: ApiCallerT,
): ApplyRequestsApi => ({
  applyRequests: async (body) => {
    const url = generateUrlBase("incidence-requests", "v1");

    const response = await apiCaller<ApplyRequestsResponseT>(
      url,
      "POST",
      body.requests,
      {},
      {},
    );

    return response;
  },
});
